// extracted by mini-css-extract-plugin
export default {"strikedOut":"vOEsy","discountLabel":"jyWJL","wrap":"hOJms","value":"fEjd9"};